@if (isDevMode) {
  <div class="card text-white bg-danger">
    <div class="card-header d-flex cursor-pointer" (click)="toggle()">
      <div class="flex-grow-1">{{ label }}</div>
      <div>
        <i class="fa fa-{{ icon }}"></i>
      </div>
    </div>
    @if (!closed) {
      <div class="card-body" [@collapseExpand]>
        <pre><ng-content></ng-content></pre>
      </div>
    }
  </div>
}
